import React from 'react';
import zhCN from 'antd/es/locale/zh_CN';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import DownloadPage from '@src/views/DownloadPage';
import Problem from '@src/views/Problem';

import './App.less';

const App = () => {
  return (
    <div>
      <ConfigProvider locale={zhCN}>
        <Router>
          <Routes>
            <Route path="/" element={<DownloadPage />} />
            <Route path="/problem" element={<Problem />} />
            <Route path="/*" element={<DownloadPage/>}></Route>
          </Routes>
        </Router>
      </ConfigProvider>
    </div>
  );
}

export default App;
